/* Merry Mischief theme — global scripts (no dependencies) */
(function () {
  'use strict';

  var MM = window.MM || {};
  var routes = MM.routes || {};
  var strings = MM.strings || {};
  var DRAWER_SECTION = 'mm-cart-drawer';

  /* ---------------- Helpers ---------------- */
  function qs(sel, root) { return (root || document).querySelector(sel); }
  function qsa(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    format = format || MM.moneyFormat || '${{amount}}';
    var value = '';
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    function withDelimiters(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands || ',';
      decimal = decimal || '.';
      if (isNaN(number) || number == null) return '0';
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsPart = parts[1] ? decimal + parts[1] : '';
      return dollars + centsPart;
    }
    var match = format.match(placeholder);
    switch (match ? match[1] : 'amount') {
      case 'amount': value = withDelimiters(cents, 2); break;
      case 'amount_no_decimals': value = withDelimiters(cents, 0); break;
      case 'amount_with_comma_separator': value = withDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = withDelimiters(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = withDelimiters(cents, 2, "'", '.'); break;
      case 'amount_with_space_separator': value = withDelimiters(cents, 2, ' ', ','); break;
      default: value = withDelimiters(cents, 2);
    }
    return format.replace(placeholder, value);
  }
  MM.formatMoney = formatMoney;

  function fetchJSON(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok || data.status) {
          var err = new Error(data.description || data.message || strings.error);
          err.data = data;
          throw err;
        }
        return data;
      });
    });
  }

  /* ---------------- Panels (menu, search, cart) ---------------- */
  var overlay = null;
  var lastFocus = null;

  function getOverlay() {
    if (!overlay) overlay = qs('[data-mm-overlay]');
    return overlay;
  }

  function openPanel(name) {
    var panel = qs('[data-mm-panel="' + name + '"]');
    if (!panel) return false;
    closeAllPanels(true);
    lastFocus = document.activeElement;
    panel.classList.add('is-open');
    panel.setAttribute('aria-hidden', 'false');
    /* Panels inside a section (menu + search live in the header) need that section lifted above the overlay */
    var hostSection = panel.closest('.shopify-section');
    if (hostSection) hostSection.classList.add('mm-raised');
    qsa('[data-mm-open="' + name + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    var ov = getOverlay();
    if (ov) { ov.hidden = false; requestAnimationFrame(function () { ov.classList.add('is-open'); }); }
    document.documentElement.classList.add('mm-lock');
    var focusTarget = qs('[data-mm-predictive-input]', panel) || panel;
    setTimeout(function () { focusTarget.focus(); }, 60);
    return true;
  }

  function closeAllPanels(keepOverlay) {
    qsa('.mm-raised').forEach(function (sec) { sec.classList.remove('mm-raised'); });
    qsa('[data-mm-panel].is-open').forEach(function (panel) {
      panel.classList.remove('is-open');
      panel.setAttribute('aria-hidden', 'true');
      var name = panel.getAttribute('data-mm-panel');
      qsa('[data-mm-open="' + name + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    });
    if (!keepOverlay) {
      var ov = getOverlay();
      if (ov) { ov.classList.remove('is-open'); setTimeout(function () { if (!ov.classList.contains('is-open')) ov.hidden = true; }, 250); }
      document.documentElement.classList.remove('mm-lock');
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }
  }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-mm-open]');
    if (opener) { e.preventDefault(); openPanel(opener.getAttribute('data-mm-open')); return; }
    if (e.target.closest('[data-mm-close]') || e.target.closest('[data-mm-overlay]')) { closeAllPanels(); return; }
    var cartToggle = e.target.closest('[data-mm-cart-toggle]');
    if (cartToggle && MM.cartType === 'drawer' && qs('[data-mm-cart-drawer]')) {
      e.preventDefault();
      openPanel('cart');
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      if (qs('[data-mm-panel].is-open')) closeAllPanels();
      qsa('details[data-mm-dropdown][open]').forEach(function (d) { d.removeAttribute('open'); });
    }
  });

  /* Close desktop dropdowns when clicking elsewhere */
  document.addEventListener('click', function (e) {
    qsa('details[data-mm-dropdown][open]').forEach(function (d) {
      if (!d.contains(e.target)) d.removeAttribute('open');
    });
  });

  /* ---------------- Cart ---------------- */
  function updateCartCount(count) {
    qsa('[data-mm-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.classList.toggle('is-empty', Number(count) === 0);
    });
  }

  function renderDrawer(html) {
    var current = qs('[data-mm-cart-drawer]');
    if (!current || !html) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = qs('[data-mm-cart-drawer]', doc);
    if (!fresh) return;
    current.innerHTML = fresh.innerHTML;
    var count = fresh.getAttribute('data-count');
    current.setAttribute('data-count', count);
    updateCartCount(count);
  }

  function refreshCountFromServer() {
    fetch(routes.cart + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { updateCartCount(cart.item_count); })
      .catch(function () {});
  }

  function addToCart(items, onError) {
    var hasDrawer = MM.cartType === 'drawer' && qs('[data-mm-cart-drawer]');
    var body = { items: items };
    if (hasDrawer) {
      body.sections = DRAWER_SECTION;
      body.sections_url = window.location.pathname;
    }
    return fetchJSON(routes.cartAdd + '.js', body)
      .then(function (data) {
        if (!hasDrawer) { window.location.href = routes.cart; return; }
        if (data.sections && data.sections[DRAWER_SECTION]) {
          renderDrawer(data.sections[DRAWER_SECTION]);
        } else {
          refreshCountFromServer();
        }
        openPanel('cart');
      })
      .catch(function (err) {
        if (onError) onError(err.message || strings.error);
      });
  }

  function changeLine(line, quantity) {
    var drawer = qs('[data-mm-cart-drawer]');
    if (drawer) drawer.classList.add('is-loading');
    return fetchJSON(routes.cartChange + '.js', {
      line: Number(line),
      quantity: Math.max(0, Number(quantity)),
      sections: DRAWER_SECTION,
      sections_url: window.location.pathname
    })
      .then(function (data) {
        if (document.body.classList.contains('template-cart')) { window.location.reload(); return; }
        if (data.sections && data.sections[DRAWER_SECTION]) renderDrawer(data.sections[DRAWER_SECTION]);
        else updateCartCount(data.item_count);
      })
      .catch(function (err) { window.alert(err.message || strings.error); })
      .then(function () {
        var d = qs('[data-mm-cart-drawer]');
        if (d) d.classList.remove('is-loading');
      });
  }

  document.addEventListener('click', function (e) {
    var lineBtn = e.target.closest('[data-mm-line]');
    if (lineBtn) {
      e.preventDefault();
      changeLine(lineBtn.getAttribute('data-mm-line'), lineBtn.getAttribute('data-qty'));
    }
  });

  /* Product forms (product page, quick add, cart upsell) */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-mm-product-form]');
    if (!form) return;
    if (!window.fetch || !window.DOMParser) return; /* let the form post normally */
    e.preventDefault();

    var root = form.closest('[data-mm-product]');
    var idInput = form.querySelector('[name="id"]');
    if (!idInput || !idInput.value) return;

    var qtyInput = null;
    /* Use getAttribute: form.id would return the <input name="id"> element, not the form's id */
    var formId = form.getAttribute('id');
    if (formId) qtyInput = document.querySelector('input[name="quantity"][form="' + formId + '"]');
    if (!qtyInput) qtyInput = form.querySelector('input[name="quantity"]');
    var qty = qtyInput ? Math.max(1, parseInt(qtyInput.value, 10) || 1) : 1;

    var items = [{ id: Number(idInput.value), quantity: qty }];
    var bundleEl = root ? qs('[data-mm-bundle]', root) : null;
    if (bundleEl && form.hasAttribute('id')) {
      var offer = qs('input[data-mm-offer]:checked', bundleEl);
      if (offer && offer.value === 'bundle') {
        var bInput = qs('[data-mm-bundle-variant]', bundleEl);
        if (!bInput || !bInput.value || bInput.getAttribute('data-available') !== 'true') {
          var errBox = qs('[data-mm-error]', root);
          var msg = strings.bundleSize || strings.error;
          if (errBox) { errBox.textContent = msg; errBox.hidden = false; } else { window.alert(msg); }
          return;
        }
        items.push({ id: Number(bInput.value), quantity: qty });
      }
    }
    if (root) {
      qsa('input[data-mm-addon]:checked', root).forEach(function (cb) {
        items.push({ id: Number(cb.value), quantity: 1 });
      });
    }

    var btn = form.querySelector('[type="submit"]');
    var label = btn ? btn.querySelector('[data-mm-atc-label]') : null;
    var original = label ? label.textContent : (btn ? btn.innerHTML : '');
    var errorEl = root ? qs('[data-mm-error]', root) : null;
    if (errorEl) { errorEl.hidden = true; errorEl.textContent = ''; }
    if (btn) { btn.disabled = true; btn.classList.add('is-loading'); }
    if (label) label.textContent = strings.adding;

    addToCart(items, function (message) {
      if (errorEl) { errorEl.textContent = message; errorEl.hidden = false; }
      else window.alert(message);
    }).then(function () {
      if (btn) { btn.disabled = false; btn.classList.remove('is-loading'); }
      if (label) label.textContent = original;
      if (root) qsa('input[data-mm-addon]:checked', root).forEach(function (cb) { cb.checked = false; });
    });
  });

  /* ---------------- Quantity buttons ---------------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-mm-qty-btn]');
    if (!b) return;
    var wrap = b.closest('.mm-qty');
    var input = wrap ? wrap.querySelector('input') : null;
    if (!input) return;
    var min = input.hasAttribute('min') ? parseInt(input.getAttribute('min'), 10) : 1;
    var val = parseInt(input.value, 10) || 0;
    val = b.getAttribute('data-mm-qty-btn') === 'plus' ? val + 1 : Math.max(min, val - 1);
    input.value = val;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* Cart page: submit when quantity changes */
  document.addEventListener('change', function (e) {
    if (e.target.matches('[data-mm-cart-qty]')) {
      var form = e.target.closest('form');
      if (form) form.submit();
    }
  });

  /* ---------------- Variant picker + gallery ---------------- */
  function initProduct(root) {
    var variantsEl = qs('[data-mm-variants]', root);
    var variants = [];
    try { variants = JSON.parse(variantsEl ? variantsEl.textContent : '[]'); } catch (err) { variants = []; }
    var picker = qs('[data-mm-variant-picker]', root);
    var idInput = qs('[data-mm-variant-id]', root);
    var atc = qs('[data-mm-atc]', root);
    var sticky = qs('[data-mm-sticky]', root);
    var stickyBtn = sticky ? qs('[data-mm-sticky-btn]', sticky) : null;
    var slider = qs('[data-mm-slider]', root);

    function goToMedia(mediaId, smooth) {
      if (!slider || !mediaId) return;
      var slide = qs('[data-media-id="' + mediaId + '"]', slider);
      if (!slide) return;
      slider.scrollTo({ left: slide.offsetLeft - slider.offsetLeft, behavior: smooth ? 'smooth' : 'auto' });
      setActiveThumb(mediaId);
    }
    function setActiveThumb(mediaId) {
      qsa('[data-mm-thumb]', root).forEach(function (t) {
        t.classList.toggle('is-active', t.getAttribute('data-mm-thumb') === String(mediaId));
      });
      var counter = qs('[data-mm-count]', root);
      if (counter && slider) {
        var slides = qsa('.mm-gallery__slide:not([data-mm-bundle-preview])', slider);
        var idx = slides.findIndex(function (sl) { return sl.getAttribute('data-media-id') === String(mediaId); });
        if (idx > -1) counter.textContent = idx + 1;
      }
    }

    qsa('[data-mm-thumb]', root).forEach(function (thumb) {
      thumb.addEventListener('click', function () { goToMedia(thumb.getAttribute('data-mm-thumb'), true); });
    });

    if (slider && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting && en.intersectionRatio > 0.6) setActiveThumb(en.target.getAttribute('data-media-id'));
        });
      }, { root: slider, threshold: [0.6] });
      qsa('[data-media-id]', slider).forEach(function (s) { io.observe(s); });
      var activeSlide = qs('.mm-gallery__slide.is-active', slider);
      if (activeSlide) goToMedia(activeSlide.getAttribute('data-media-id'), false);
    }

    function setButtons(variant) {
      var available = variant && variant.available;
      var text = !variant ? strings.unavailable : (available ? strings.addToCart : strings.soldOut);
      [atc, stickyBtn].forEach(function (btn) {
        if (!btn) return;
        btn.disabled = !available;
        var label = qs('[data-mm-atc-label]', btn);
        if (label) label.textContent = text;
      });
    }

    function setPrice(variant) {
      if (!variant) return;
      qsa('[data-mm-price]', root).forEach(function (el) {
        var html = '<span class="mm-price__now">' + formatMoney(variant.price) + '</span>';
        if (MM.showCompare && variant.compare_at_price && variant.compare_at_price > variant.price) {
          html += '<s class="mm-price__was">' + formatMoney(variant.compare_at_price) + '</s>';
        }
        el.innerHTML = html;
      });
    }

    function onChange() {
      if (!picker) return;
      var selected = qsa('fieldset[data-option-index]', picker).map(function (fs) {
        var checked = qs('input:checked', fs);
        var labelEl = qs('[data-mm-option-label]', fs);
        if (checked && labelEl) labelEl.textContent = checked.value;
        return checked ? checked.value : null;
      });
      var variant = variants.find(function (v) {
        return v.options.every(function (opt, i) { return opt === selected[i]; });
      });
      setButtons(variant);
      if (!variant) return;
      if (idInput) idInput.value = variant.id;
      setPrice(variant);
      var bundleEl = qs('[data-mm-bundle]', root);
      if (bundleEl) bundleEl.dispatchEvent(new Event('change'));
      if (variant.featured_media) goToMedia(variant.featured_media.id, true);
      var url = root.getAttribute('data-url');
      if (url && window.history.replaceState) window.history.replaceState({}, '', url + '?variant=' + variant.id);
    }
    if (picker) picker.addEventListener('change', onChange);

    /* Sticky add to cart */
    if (sticky && atc) {
      /* Show only once the main Add to Cart button has been scrolled past (never on load) */
      var ticking = false;
      var checkSticky = function () {
        ticking = false;
        var r = atc.getBoundingClientRect();
        var show = r.bottom < 0;
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
        if (stickyBtn) stickyBtn.tabIndex = show ? 0 : -1;
      };
      window.addEventListener('scroll', function () {
        if (!ticking) { ticking = true; window.requestAnimationFrame(checkSticky); }
      }, { passive: true });
      window.addEventListener('resize', checkSticky);
      checkSticky();
      if (stickyBtn) {
        stickyBtn.addEventListener('click', function () {
          var form = atc.form;
          if (!form) return;
          if (form.requestSubmit) form.requestSubmit(atc);
          else atc.click();
        });
      }
    }
  }

  /* ---------------- Bundle picker (single vs bundle) ---------------- */
  function initBundle(root) {
    var el = qs('[data-mm-bundle]', root);
    if (!el || el.getAttribute('data-mm-ready')) return;
    el.setAttribute('data-mm-ready', '1');
    var save = parseInt(el.getAttribute('data-save'), 10) || 0;
    var styleIndex = parseInt(el.getAttribute('data-style-index'), 10);
    var sizeIndex = parseInt(el.getAttribute('data-size-index'), 10);
    var hidden = qs('[data-mm-bundle-variant]', el);
    var sizeSelect = qs('[data-mm-bundle-size-select]', el);
    var sizeWrap = qs('[data-mm-bundle-size]', el);
    var stylesWrap = qs('[data-mm-bundle-styles]', el);
    var styleName = qs('[data-mm-bundle-style-name]', el);
    var swatches = qsa('[data-mm-bundle-style]', el);
    var bundleRadio = qs('input[data-mm-offer][value="bundle"]', el);
    var priceEls = qsa('[data-mm-price]', root);
    var slider = qs('[data-mm-slider]', root);
    var bVariants = [];
    try { bVariants = JSON.parse(qs('[data-mm-bundle-variants]', el).textContent); } catch (e) { bVariants = []; }
    var activeSwatch = swatches.filter(function (b) { return b.classList.contains('is-active'); })[0];
    var style = activeSwatch ? activeSwatch.getAttribute('data-mm-bundle-style') : null;

    function size() { return sizeSelect ? sizeSelect.value : null; }
    function matches(v, st, sz) {
      return (styleIndex < 0 || v.options[styleIndex] === st) && (sizeIndex < 0 || v.options[sizeIndex] === sz);
    }
    function currentVariant() {
      return bVariants.filter(function (v) { return matches(v, style, size()); })[0] || null;
    }
    function refreshSizes() {
      if (!sizeSelect) return;
      Array.prototype.forEach.call(sizeSelect.options, function (o) {
        var v = bVariants.filter(function (x) { return matches(x, style, o.value); })[0];
        var ok = !!(v && v.available);
        o.disabled = !ok;
        o.textContent = (o.getAttribute('data-label') || o.value) + (ok ? '' : ' - ' + (strings.soldOut || 'Sold out'));
      });
      if (sizeSelect.options[sizeSelect.selectedIndex] && sizeSelect.options[sizeSelect.selectedIndex].disabled) {
        var firstOk = Array.prototype.filter.call(sizeSelect.options, function (o) { return !o.disabled; })[0];
        if (firstOk) sizeSelect.value = firstOk.value;
      }
    }
    function singlePrice() {
      var variantsEl = qs('[data-mm-variants]', root);
      var idInput = qs('[data-mm-variant-id]', root);
      try {
        var vs = JSON.parse(variantsEl.textContent);
        var cur = vs.find(function (v) { return String(v.id) === String(idInput.value); });
        return cur ? cur.price : 0;
      } catch (e) { return 0; }
    }
    function previewSlide() {
      if (!slider) return null;
      var slide = qs('[data-mm-bundle-preview]', slider);
      if (!slide) {
        slide = document.createElement('div');
        slide.className = 'mm-gallery__slide mm-gallery__slide--preview';
        slide.setAttribute('data-mm-bundle-preview', '');
        slide.setAttribute('data-media-id', 'bundle-preview');
        slide.hidden = true;
        var img = document.createElement('img');
        img.alt = '';
        img.decoding = 'async';
        slide.appendChild(img);
        slider.insertBefore(slide, slider.firstChild);
      }
      return slide;
    }
    function showPreview(url) {
      var slide = previewSlide();
      if (!slide || !url) return;
      var img = slide.querySelector('img');
      if (img.getAttribute('src') !== url) img.setAttribute('src', url);
      slide.hidden = false;
      slider.scrollTo({ left: 0, behavior: 'auto' });
      qsa('[data-mm-thumb]', root).forEach(function (t) { t.classList.remove('is-active'); });
    }
    function hidePreview() {
      var slide = slider ? qs('[data-mm-bundle-preview]', slider) : null;
      if (!slide || slide.hidden) return;
      slide.hidden = true;
      slider.scrollTo({ left: 0, behavior: 'auto' });
      var firstThumb = qs('[data-mm-thumb]', root);
      if (firstThumb) {
        var id = firstThumb.getAttribute('data-mm-thumb');
        qsa('[data-mm-thumb]', root).forEach(function (t) { t.classList.toggle('is-active', t.getAttribute('data-mm-thumb') === id); });
      }
    }
    function update() {
      var offer = qs('input[data-mm-offer]:checked', el);
      var isBundle = !!(offer && offer.value === 'bundle');
      el.classList.toggle('is-bundle', isBundle);
      if (sizeWrap) sizeWrap.hidden = !isBundle;
      if (stylesWrap) stylesWrap.hidden = !isBundle;
      refreshSizes();
      var v = currentVariant();
      if (hidden) {
        hidden.value = v ? v.id : '';
        hidden.setAttribute('data-price', v ? v.price : 0);
        hidden.setAttribute('data-available', v && v.available ? 'true' : 'false');
      }
      var extra = v ? v.price : 0;
      var full = singlePrice() + extra;
      var bundle = full - save;
      var bp = qs('[data-mm-bundle-price]', el);
      var bw = qs('[data-mm-bundle-was]', el);
      if (bp) bp.textContent = formatMoney(bundle);
      if (bw) bw.textContent = formatMoney(full);
      if (isBundle) {
        priceEls.forEach(function (p) {
          p.innerHTML = '<span class="mm-price__now">' + formatMoney(bundle) + '</span>' + (save > 0 ? '<s class="mm-price__was">' + formatMoney(full) + '</s>' : '');
        });
      } else {
        if (el.classList.contains('was-bundle')) {
          priceEls.forEach(function (p) { p.innerHTML = '<span class="mm-price__now">' + formatMoney(singlePrice()) + '</span>'; });
        }
        hidePreview();
      }
      el.classList.toggle('was-bundle', isBundle);
      var err = qs('[data-mm-error]', root);
      if (err) err.hidden = true;
    }
    swatches.forEach(function (b) {
      b.addEventListener('click', function (e) {
        e.preventDefault();
        style = b.getAttribute('data-mm-bundle-style');
        swatches.forEach(function (x) {
          var on = x === b;
          x.classList.toggle('is-active', on);
          x.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        if (styleName) styleName.textContent = style;
        var cardImg = qs('.mm-offer__preview-img', el);
        var small = b.getAttribute('data-img-sm');
        if (cardImg && small) {
          cardImg.removeAttribute('srcset');
          cardImg.setAttribute('src', small);
          cardImg.setAttribute('alt', style);
        }
        if (bundleRadio && !bundleRadio.checked) bundleRadio.checked = true;
        update();
        showPreview(b.getAttribute('data-img'));
      });
    });
    el.addEventListener('change', update);
    update();
  }

  /* ---------------- Recommendations ---------------- */
  function initRecs(el) {
    var url = el.getAttribute('data-url');
    if (!url) return;
    fetch(url)
      .then(function (r) { return r.text(); })
      .then(function (text) {
        var doc = new DOMParser().parseFromString(text, 'text/html');
        var fresh = qs('[data-mm-recs]', doc);
        if (fresh && fresh.innerHTML.trim().length) el.innerHTML = fresh.innerHTML;
      })
      .catch(function () {});
  }

  /* ---------------- Predictive search ---------------- */
  function initPredictive() {
    var input = qs('[data-mm-predictive-input]');
    var results = qs('[data-mm-predictive-results]');
    if (!input || !results || !MM.predictive || !routes.predictive) return;
    var timer = null;
    var controller = null;
    input.addEventListener('input', function () {
      var q = input.value.trim();
      clearTimeout(timer);
      if (q.length < 2) { results.innerHTML = ''; return; }
      timer = setTimeout(function () {
        if (controller && controller.abort) controller.abort();
        controller = window.AbortController ? new AbortController() : null;
        var url = routes.predictive + '?q=' + encodeURIComponent(q) +
          '&resources[type]=product,collection,page&resources[limit]=6&section_id=mm-predictive-search';
        fetch(url, controller ? { signal: controller.signal } : {})
          .then(function (r) { return r.text(); })
          .then(function (text) {
            var doc = new DOMParser().parseFromString(text, 'text/html');
            var sec = qs('#shopify-section-mm-predictive-search', doc);
            results.innerHTML = sec ? sec.innerHTML : '';
          })
          .catch(function () {});
      }, 250);
    });
  }

  /* ---------------- Announcement rotator ---------------- */
  function initRotator(el) {
    var msgs = qsa('.mm-ann__msg', el);
    if (msgs.length < 2) return;
    var i = 0;
    var interval = (parseInt(el.getAttribute('data-interval'), 10) || 5) * 1000;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) interval = interval * 2;
    setInterval(function () {
      msgs[i].classList.remove('is-active');
      i = (i + 1) % msgs.length;
      msgs[i].classList.add('is-active');
    }, interval);
  }

  /* ---------------- Auto-submit (filters, sort, country) ---------------- */
  document.addEventListener('change', function (e) {
    if (e.target.matches('[data-mm-autosubmit]')) {
      var form = e.target.form || e.target.closest('form');
      if (form) form.submit();
    }
  });

  /* ---------------- Init ---------------- */
  function init() {
    qsa('[data-mm-product]').forEach(initProduct);
    qsa('[data-mm-product]').forEach(initBundle);
    qsa('[data-mm-recs]').forEach(initRecs);
    qsa('[data-mm-rotator]').forEach(initRotator);
    initPredictive();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  /* Theme editor: re-init sections when edited */
  document.addEventListener('shopify:section:load', function (e) {
    qsa('[data-mm-product]', e.target).forEach(initProduct);
    qsa('[data-mm-product]', e.target).forEach(initBundle);
    qsa('[data-mm-recs]', e.target).forEach(initRecs);
    qsa('[data-mm-rotator]', e.target).forEach(initRotator);
    if (qs('[data-mm-predictive-input]', e.target)) initPredictive();
  });

  window.MM = MM;
})();
